import Constant from '@/const';
import axios from 'axios';

const deleteRecipeDrug = async (idDrug, idRecipe) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/patient/recipe/${idRecipe}/${idDrug}`),
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export default deleteRecipeDrug;
